<template>
	<div class="job-details">
		<JobDescription />
		<JobStatus :job_status="job_status" :staff_name="staff_name" />
		<button
			class="job-details-btn"
			@click.prevent="loadMore"
			v-if="isLastEvaluatedKey"
		>
			Load earlier messages
		</button>
		<PostCard
			v-for="post in reversePosts"
			:post="post"
			:key="post.post_id"
		/>
		<CreatePost :job_id="job.job_id" :job_status="job_status" />
	</div>
</template>

<script>
import JobDescription from '@/components/JobDescription.vue'
import JobStatus from '@/components/JobStatus.vue'
import CreatePost from '@/components/CreatePost.vue'
import PostCard from '@/components/PostCard.vue'
import { mapState } from 'vuex'
import { isStaff } from '@/utils/Help.js'

export default {
	name: 'JobDetails',
	components: {
		JobDescription,
		CreatePost,
		PostCard,
		JobStatus
	},
	computed: {
		...mapState({
			job: state => state.job.job,
			posts: state => state.post.posts,
			isLastEvaluatedKey: state => state.post.isLastEvaluatedKey,
			exclusivestartkey: state => state.post.exclusivestartkey
		}),
		job_status() {
			return this.job.job_status
		},
		staff_name() {
			return this.job.staff_name
		},
		reversePosts: function() {
			let reversePosts = []
			reversePosts = reversePosts.concat(this.posts)
			reversePosts.reverse()
			return reversePosts
		},
		isStaff() {
			return isStaff()
		}
	},
	methods: {
		async loadMore() {
			await this.$store.dispatch('post/getPosts', {
				job_id: this.job.job_id,
				pageSize: 1000,
				exclusivestartkey: this.exclusivestartkey
			})
		},
		async jobApproveClick() {
			await this.$store.dispatch('job/approveJob', {
				job_id: this.job.job_id
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/views/jobDetails.scss';
</style>
